<template>
	<div class="qty-container">
		<BaseThemeWebshopQty :quantity="props.quantity" :limit="props.limit" :item="props.item" v-model="item.qty" :mode="props.mode" />
	</div>
</template>

<script setup>
	const props = defineProps({
		item: {
			type: Object,
			required: true,
		},
		mode: {
			type: String,
		},
		limit: [Number, String],
		quantity: [Number, String],
	})
</script>

<style lang="less">
	.qty-container{position: relative; display: flex; flex-flow: column; align-items: center; width: 95px; flex-grow: 0; flex-shrink: 0;}
	.qty-input{font-size: 12px; text-align: center; padding: 0 30px; height: 48px;}
	.qty-btn{
		position: absolute; width: 28px; height: 100%; font-size: 0; display: flex; align-items: center; top: 0; left: 0; cursor: pointer;
		&:before{.pseudo(12px,2px); background: var(--blue2); border-radius: 1px; .transition(background);}
		&:after{.pseudo(2px,12px); background: var(--blue2); border-radius: 1px; left: 5px; .transition(background);}
		@media (min-width: @h){
			&:hover{
				&:before, &:after{background: var(--blue);}
			}
		}
	}
	.qty-btn-inc{left: auto; right: 0;}
	.qty-btn-dec{justify-content: flex-end; z-index: 1;}
	.qty-btn-dec:after{display: none;}
</style>
